
export enum DBFunctionsCompany {
  mutateCompany = 'mutateCompany',
  listCompany = 'listCompany',
  mutateCompanyLink = 'mutateCompanyLink',
  listCompanyLink = 'listCompanyLink',
}

export enum DBFunctionsUser {
  signup = 'signup',
  signin = 'signin',
  users = 'users',
  mutateUser = 'mutateUser',
  listCompanyUser = 'listCompanyUser',
  mutateUserCompany = 'mutateUserCompany',
  getUser = 'getUser',
  setAuth = 'setAuth',
}

export enum DBFunctionStorage {
  getUploadUrl = 'getUploadUrl',
  getDownloadUrl = 'getDownloadUrl',
  listAttachment = 'listAttachment',
  mutateAttachment = 'mutateAttachment',
}

export enum DBFunctionProductModel {
  mutateProductModel = 'mutateProductModel',
  listProductModel = 'listProductModel',
  mutateProductModelOptional = 'mutateProductModelOptional',
  listProductModelOptional = 'listProductModelOptional',
  mutateProductModelMeasureGroup = 'mutateProductModelMeasureGroup',
  listProductModelMeasureGroup = 'listProductModelMeasureGroup',
  listProductModelColor = 'listProductModelColor',
  listProductModelOptionalDetail = 'listProductModelOptionalDetail',


}

export enum DBFunctionPantone {
  listColor = 'listColor',
  mutateColor = 'mutateColor',
  listPantone = 'listPantone',
  mutatePantone = 'mutatePantone',
  listPantoneColor = 'listPantoneColor',
  mutatePantoneColor = 'mutatePantoneColor',
  listPantoneProductModel = 'listPantoneProductModel',
  mutatePantoneProductModel = 'mutatePantoneProductModel',
  listMaterialTypeColor = 'listMaterialTypeColor'
}

export enum DBFunctionOptional {
  mutateOptional = 'mutateOptional',
  listOptional = 'listOptional',
  mutateOptionalDetail = 'mutateOptionalDetail',
  listOptionalDetail = 'listOptionalDetail',
  mutateOptionalDetailLink = 'mutateOptionalDetailLink',
  listOptionalDetailWithLink = 'listOptionalDetailWithLink',
  listAccessory = 'listAccessory',
  mutateAccessory = 'mutateAccessory',
}

export enum DBFunctionMeasure {
  mutateMeasure = 'mutateMeasure',
  listMeasure = 'listMeasure',
  mutateMeasureGroup = 'mutateMeasureGroup',
  listMeasureGroup = 'listMeasureGroup',
}

export enum DBFunctionMisc {
  listCodeTables = 'listCodeTables',
  mutateCodeTables = 'mutateCodeTables',
  listCodeTablesName = 'listCodeTablesName',
  mutateCodeTablesName = 'mutateCodeTablesName',
}

export enum DBFunctionRegistry {
  mutateRegistry = 'mutateRegistry',
  listRegistry = 'listRegistry',
}

export enum DBFunctionQuote {
  mutateQuote = 'mutateQuote',
  listQuote = 'listQuote',
  mutateQuoteDetail = 'mutateQuoteDetail',
  listQuoteDetail = 'listQuoteDetail',
  mutateQuoteOptional = 'mutateQuoteOptional',
  listQuoteOptional = 'listQuoteOptional',
  mutateQuoteVersion = 'mutateQuoteVersion',
  listQuoteVersion = 'listQuoteVersion',
  getQuoteData = 'getQuoteData',
  mutateQuoteDetailOptional = 'mutateQuoteDetailOptional',
  listQuoteDetailOptional = 'listQuoteDetailOptional',
  listQuoteAccessory = 'listQuoteAccessory',
  mutateQuoteAccessory = 'mutateQuoteAccessory',
  quoteCalculatePrice = 'quoteCalculatePrice',
  mutateQuoteStatus = 'mutateQuoteStatus',
  cloneQuote = 'cloneQuote',
}

export enum DBFunctionPrice {
  mutatePriceGroupMeasure = 'mutatePriceGroupMeasure',
  listPriceGroupMeasure = 'listPriceGroupMeasure',
  mutatePriceMeasure = 'mutatePriceMeasure',
  listPriceMeasure = 'listPriceMeasure',
  mutateProductModelOptionalPriceGroupMeasure = 'mutateProductModelOptionalPriceGroupMeasure',
  listProductModelOptionalPriceGroupMeasure = 'listProductModelOptionalPriceGroupMeasure',
  getProductModelMeasurePrice = 'getProductModelMeasurePrice',
}